import { isFilled } from "@prismicio/client";
import { PrismicImage, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.TechnologiesSlice} TechnologiesSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TechnologiesSlice>} TechnologiesProps
 * @type {import("react").FC<TechnologiesProps>}
 */
const Technologies = ({ slice, index, context }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`framing padding-x ${index === 0 ? "padding-y-first" : "padding-y"} text-black`}
    >
      <div className={`flex flex-col gap-2.5 ${slice.variation === "default" ? "text-center" : "text-start"}`}>
        {isFilled.richText(slice.primary.title) && (
          <PrismicRichText
            field={slice.primary.title}
            components={{
              heading1: ({ children }) => <h1 className="h2">{children}</h1>,
              heading2: ({ children }) => <h2 className="h2">{children}</h2>,
            }}
          />
        )}

        {isFilled.richText(slice.primary.subtitle) && (
          <PrismicRichText
            field={slice.primary.subtitle}
            components={{
              heading2: ({ children }) => <h2 className="h3">{children}</h2>,
              heading3: ({ children }) => <h3 className="h3 mb-2">{children}</h3>,
            }}
          />
        )}
        
        {isFilled.richText(slice.primary.text) && (
          <PrismicRichText
            field={slice.primary.text}
            components={{
              paragraph: ({ children }) => <p className="p-sm">{children}</p>,
            }}
          />
        )}
      </div>
      {Array.isArray(slice.primary.images) && slice.primary.images.length > 0 && (
        <div className="flex grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {slice.primary.images.map((item, index) => (
            <div key={index} className="h-60 relative">
              {isFilled.image(item.img) && (
                <PrismicImage className="h-full w-full object-cover object-center rounded-lg"
                  field={{
                    ...item.img,
                    alt: item.img.alt || "Image d'illustration",
                  }}
                />
              )}
              {isFilled.keyText(item.text) && <div className="absolute bottom-3 px-4 w-full">
                <p className="text-white w-fit bg-orange px-2 rounded-lg font-bold">{item.text}</p>
                </div>}
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default Technologies;
